"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Parser = _interopRequireDefault(require("./Parser"));

var EmbeddedVideo = /*#__PURE__*/function (_PureComponent) {
  (0, _inheritsLoose2["default"])(EmbeddedVideo, _PureComponent);

  function EmbeddedVideo() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = EmbeddedVideo.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var handleParse = this.props.handleParse;
    handleParse();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        href = _this$props.href,
        width = _this$props.width,
        showText = _this$props.showText,
        allowFullScreen = _this$props.allowFullScreen,
        autoPlay = _this$props.autoPlay,
        showCaptions = _this$props.showCaptions,
        children = _this$props.children;
    return _react["default"].createElement("div", {
      className: "fb-video",
      "data-href": href,
      "data-width": width,
      "data-show-text": showText,
      "data-show-captions": showCaptions,
      "data-autoplay": autoPlay,
      "data-allowfullscreen": allowFullScreen
    }, children);
  };

  return EmbeddedVideo;
}(_react.PureComponent);

(0, _defineProperty2["default"])(EmbeddedVideo, "defaultProps", {
  width: undefined,
  showText: undefined,
  allowFullScreen: undefined,
  autoPlay: undefined,
  showCaptions: undefined,
  children: undefined
});

var _default = (0, _react.forwardRef)(function (props, ref) {
  return _react["default"].createElement(_Parser["default"], null, function (_ref) {
    var handleParse = _ref.handleParse;
    return _react["default"].createElement(EmbeddedVideo, (0, _extends2["default"])({}, props, {
      handleParse: handleParse,
      ref: ref
    }));
  });
});

exports["default"] = _default;